'use client';

import React, { useState } from 'react';
import { Menu, Bell, Search, ChevronDown } from 'lucide-react';

interface TopbarProps {
  onMobileMenuOpen: () => void;
  sidebarCollapsed: boolean;
}

export default function Topbar({ onMobileMenuOpen }: TopbarProps) {
  const [showNotifications, setShowNotifications] = useState(false);

  const notifications = [
    { id: 'notif-1', text: 'Invoice #INV-10482 is now overdue', time: '2 min ago', type: 'overdue' },
    { id: 'notif-2', text: 'PO #PO-2847 acknowledged by supplier', time: '14 min ago', type: 'info' },
    { id: 'notif-3', text: 'New job #JOB-CRM-9921 received from CRM', time: '1 hr ago', type: 'info' },
    { id: 'notif-4', text: 'Invoice #INV-10475 marked as paid', time: '3 hr ago', type: 'success' },
  ];

  return (
    <header
      className="flex items-center justify-between h-16 px-6 border-b flex-shrink-0 bg-card"
      style={{ borderColor: 'var(--border)' }}
    >
      {/* Left */}
      <div className="flex items-center gap-3">
        <button
          onClick={onMobileMenuOpen}
          className="lg:hidden p-1.5 rounded-md hover:bg-muted transition-colors"
          aria-label="Open menu"
        >
          <Menu size={20} style={{ color: 'var(--slate)' }} />
        </button>
        <div
          className="hidden sm:flex items-center gap-2 px-3 py-2 rounded-md border text-sm"
          style={{ borderColor: 'var(--border)', backgroundColor: 'var(--cloud)', color: 'var(--slate)', minWidth: '220px' }}
        >
          <Search size={14} style={{ color: 'var(--slate)' }} />
          <span className="text-sm" style={{ color: 'var(--slate)' }}>Search jobs, invoices, POs…</span>
          <kbd
            className="ml-auto text-xs px-1.5 py-0.5 rounded font-mono"
            style={{ backgroundColor: 'var(--muted)', color: 'var(--slate)', fontSize: '10px' }}
          >
            ⌘K
          </kbd>
        </div>
      </div>

      {/* Right */}
      <div className="flex items-center gap-2">
        {/* Notifications */}
        <div className="relative">
          <button
            onClick={() => setShowNotifications(!showNotifications)}
            className="relative p-2 rounded-md hover:bg-muted transition-colors"
            aria-label="Notifications"
          >
            <Bell size={18} style={{ color: 'var(--slate)' }} />
            <span
              className="absolute top-1 right-1 w-2 h-2 rounded-full border-2 border-white"
              style={{ backgroundColor: 'var(--amber)' }}
            />
          </button>
          {showNotifications && (
            <div
              className="absolute right-0 top-full mt-2 w-80 rounded-lg border shadow-lg z-50 fade-in"
              style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}
            >
              <div className="px-4 py-3 border-b" style={{ borderColor: 'var(--border)' }}>
                <p className="text-sm font-semibold" style={{ color: 'var(--foreground)' }}>Notifications</p>
              </div>
              <div className="max-h-64 overflow-y-auto">
                {notifications.map((n) => (
                  <div
                    key={n.id}
                    className="px-4 py-3 border-b last:border-0 hover:bg-muted/50 cursor-pointer transition-colors"
                    style={{ borderColor: 'var(--border)' }}
                  >
                    <p className="text-sm" style={{ color: 'var(--foreground)' }}>{n.text}</p>
                    <p className="text-xs mt-0.5" style={{ color: 'var(--slate)' }}>{n.time}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* User menu */}
        <button
          className="flex items-center gap-2 px-3 py-2 rounded-md hover:bg-muted transition-colors"
        >
          <div
            className="w-7 h-7 rounded-full flex items-center justify-center text-white text-xs font-semibold flex-shrink-0"
            style={{ backgroundColor: 'var(--ink)' }}
          >
            MW
          </div>
          <div className="hidden sm:block text-left">
            <p className="text-sm font-medium leading-tight" style={{ color: 'var(--foreground)' }}>Marcus Webb</p>
            <p className="text-xs leading-tight" style={{ color: 'var(--slate)' }}>Finance Team</p>
          </div>
          <ChevronDown size={14} style={{ color: 'var(--slate)' }} />
        </button>
      </div>
    </header>
  );
}